(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pdp-accordion')) {
    customElements.define(
      'pdp-accordion',
      class PdpAccordion extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.items = Array.from(this.querySelectorAll('details.pdp-accordion__item'));
          this.items.forEach((item) => {
            const summary = item.querySelector('summary');
            if (!summary) return;
            summary.addEventListener('click', (event) => this.onSummaryClick(event, item, summary));
          });
        }

        onSummaryClick(event, item, summary) {
          event.preventDefault();
          const top = summary.getBoundingClientRect().top;
          const opening = !item.open;

          if (opening) {
            this.items.forEach((other) => {
              if (other !== item) other.open = false;
            });
            item.open = true;
          } else {
            item.open = false;
          }

          const keepInPlace = () => {
            const delta = summary.getBoundingClientRect().top - top;
            if (Math.abs(delta) > 0.5) window.scrollBy(0, delta);
          };

          keepInPlace();
          requestAnimationFrame(() => {
            keepInPlace();
            requestAnimationFrame(keepInPlace);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
